import { LOGIN_MUTATION } from "../graphql/mutations/user/mutations";
import { FILTER_USER } from "../graphql/query/user/query";
import { apiRequests} from "../services/api";

/** MUTATIONS */
export const loginUser = async (email,password) => {
    //return apiRequests(LOGIN_MUTATION,{email , password});
    try {
        //console.log(email,password);
        const response = await apiRequests(LOGIN_MUTATION,{email,password});
        //console.log('444',response.data.loginAdmin.message);
        if(response?.data?.loginAdmin?.user ){
            return {
                success:true,
                user: response.data.loginAdmin.user,
                role: response.data.loginAdmin.role,
                permissions: response.data.loginAdmin.permissions,
                token: response.data.loginAdmin.user.token,
                message: response.data.loginAdmin.message,
            };
        }
    const msg = response?.data?.loginAdmin?.message;
    return {
        success: false,
        message: msg || "Credenciales incorrectas. Verifica tu email y contraseña."
    };

    } catch (error) {
        return {
            success: false,
            message: "Ocurrió un error en el inicio de sesión. Inténtalo de nuevo." , error
        };
    }
};

/** QUERIES */

export const filtersUser = async (email) => {
    try {
        const variables = {
            email:email
        }
        const response = await apiRequests(FILTER_USER , variables);
        //console.log('123',response);
        if(response.data?.filterUser?.user){
            return response.data.filterUser.user;
        }else {
            //console.log('123456789');
            return response.data.filterUser;
        }
    } catch(err){
        console.log('Ups surgio un problema ' , err);
        return null;
    }
}